// Plan-Content — Tagline + Benefit-Checkliste pro Abo-Plan (keyed by plan.id).
// Strategie A: Credits + Wert kommunizieren, kein Feature-Gating.
// Fallback für unbekannte Plan-IDs, damit neue Admin-Pläne nicht brechen.

import type { SubscriptionPlan } from '@/lib/subscriptions-api';

export interface PlanContent {
  tagline: string;
  checklist: ReadonlyArray<string>;
}

const PLAN_CONTENT: Readonly<Record<string, PlanContent>> = {
  plan_s: {
    tagline: 'Für den Einstieg',
    checklist: [
      'Alle EVE-Bereiche frei nutzbar',
      '500 Credits jeden Monat',
      'Credits jederzeit nachkaufbar',
      'Monatlich kündbar',
    ],
  },
  plan_m: {
    tagline: 'Für aktive Trader',
    checklist: [
      'Alles aus Starter',
      '5× mehr Credits pro Monat',
      'Deutlich günstiger pro Credit',
      'Bestes Preis-Leistungs-Verhältnis',
    ],
  },
  plan_l: {
    tagline: 'Für Power-User',
    checklist: [
      'Alles aus Pro',
      '20× mehr Credits pro Monat',
      'Günstigster Preis pro Credit',
      'Maximales Monats-Volumen',
    ],
  },
};

/** Liefert Tagline + Checkliste für einen Plan, mit generischem Fallback. */
export function getPlanContent(plan: SubscriptionPlan): PlanContent {
  const mapped = PLAN_CONTENT[plan.id];
  if (mapped) return mapped;
  return {
    tagline: 'Credits jeden Monat',
    checklist: [`${plan.credits_per_month.toLocaleString('de-DE')} Credits jeden Monat`],
  };
}
